import { render, staticRenderFns } from "./target_filter.vue?vue&type=template&id=636a12fc&scoped=true"
import script from "./target_filter.vue?vue&type=script&lang=js"
export * from "./target_filter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "636a12fc",
  null
  
)

export default component.exports